// Chest window (UI-3; M6.2). 27 storage slots over a chest block entity plus the
// player inventory, driven by the same generic container machinery as crafting —
// all mutations flow through transaction.clickSlot (PLR-1). Client-only (ENG-1).
import { chestSlots, fillChestLoot, type ChestData } from '../../../sim/game/containers/chest';
import { maxStackFn, playerRefs, playerRows } from './crafting';
import { openWindow, refRange, returnToInventory, type SlotRef, type WindowConfig } from './container';
import type { Game } from '../../boot';

/** Open a chest block entity — realises pending loot on first open. */
export function openChest(game: Game, chest: ChestData): () => void {
  // Structure chests roll here (once); the explorer-map seam lets a shipwreck's
  // map chest hand out a map already pinned to buried treasure.
  fillChestLoot(chest, game.registries, { explorerMap: (d) => game.explorerMap(d) });
  const slots = chestSlots(chest, maxStackFn(game.registries));
  const chestRefs = refRange(slots, 0, 27, undefined, 'chest');
  const pr = playerRefs(game.playerState.inventory);
  const chestSet = new Set<object>([slots]);

  const rows: (SlotRef | null)[][] = [];
  for (let r = 0; r < 3; r++) rows.push(chestRefs.slice(r * 9, r * 9 + 9));
  rows.push([null]); // gap before the player panel

  const cfg: WindowConfig = {
    title: 'Chest',
    layout: [...rows, ...playerRows(pr)],
    // Shift-click: chest → player, player → chest.
    quickTargets: (ref) => (chestSet.has(ref.slots) ? [...pr.storage, ...pr.hotbar] : chestRefs),
    onClose: (cursor) => returnToInventory(game, [cursor]),
  };
  return openWindow(game, cfg);
}
